export const URL = 'localhost:3001'
export const HTTP_URL = 'http://' + URL
// export const baseURL = process.env.API_BASE_URL || 'http://localhost:3003'
export const baseURL = 'https://dev-api.ayeface.com'
